jQuery(document).ready(function() {
	// load slider for Headslider

jQuery('.beitragsslider').slick({
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 14000
});


jQuery('.postslider').slick({
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 4,
  arrows: true,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1100,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
  ]
});

  jQuery('.slick-slide .rezept .mediawrap').on('wheel', (function(e) {
    e.preventDefault();

    if (e.originalEvent.deltaY < 0) {
      jQuery('.rezeptslider').slick('slickPrev');
    } else {
      jQuery('.rezeptslider').slick('slickNext');
    }
  }));


jQuery('<svg version="1.1" id="Ebene_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 69.7 69.7" style="enable-background:new 0 0 69.7 69.7;" xml:space="preserve"><style type="text/css"> .st0{fill:#010202;} .st1{fill:none;}</style> <g id="Gruppe_359" transform="translate(-983.341 1066) rotate(-90)"><g id="Icon_feather-arrow-down" transform="translate(1024.453 1000.16)"><path class="st0" d="M5.1,29.3V4.9c0-0.8,0.7-1.5,1.5-1.5S8.1,4,8.1,4.9v24.4c0,0.8-0.7,1.5-1.5,1.5S5.1,30.1,5.1,29.3z"/><path class="st0" d="M-7.1,17.1c0-0.4,0.1-0.8,0.4-1.1c0.6-0.6,1.5-0.6,2.1,0L6.6,27.2L17.8,16c0.6-0.6,1.5-0.6,2.1,0 c0.6,0.6,0.6,1.5,0,2.1L7.7,30.4c-0.6,0.6-1.5,0.6-2.1,0L-6.6,18.2C-6.9,17.9-7.1,17.5-7.1,17.1z"/></g> <g id="Ellipse_7" transform="translate(1007 983.341)"><circle class="st1" cx="23.9" cy="34.4" r="29.5"/><path class="st0" d="M-5.6,34.4c0-16.3,13.2-29.5,29.5-29.5s29.5,13.2,29.5,29.5S40.2,63.9,23.9,63.9S-5.6,50.6-5.6,34.4z M51.4,34.4c0-15.2-12.3-27.5-27.5-27.5S-3.6,19.2-3.6,34.4S8.8,61.9,23.9,61.9S51.4,49.5,51.4,34.4z"/></g></g></svg>').appendTo( ".slick-next ,.slick-prev");

});

